import format from '@/module/util/format'
import formatValue from '../format/format-value'

export default {
    props: {
		vital: {
			type: String,
			required: true
		},
		event: {
			type: Array,
			required: true
		}
	},

    methods: {
        ...format,
        formatValue
    }
}
